import { expect, Page } from "@playwright/test";
import {
    getFilterButton,
    getFilterTags,
} from "../utils/stateful-overview-utils";

export const testApplyFilters = async (page: Page) => {
    const filterButton = getFilterButton(page);
    await expect(filterButton).toBeVisible();
    await expect(filterButton.getByText("Filter")).toBeVisible();
    await expect(filterButton.locator(".ux-badge")).not.toBeVisible();

    // Sidebar should open
    await filterButton.click();
    const sidebar = page.locator("ux-sidebar").first();
    await expect(sidebar.locator("ux-sidebar-content")).toBeVisible();

    // Check checkbox
    const checkbox = sidebar
        .locator("ux-filter > form > div > div:nth-child(2) > ux-checkbox")
        .first();
    await checkbox.click();
    await expect(checkbox.locator("input")).toBeChecked();

    // Display filter tags
    await sidebar.locator("ux-button").first().click();
    await expect(filterButton.locator(".ux-badge")).toBeVisible();
    await expect(
        filterButton.locator(".ux-badge").getByText("1")
    ).toBeVisible();
    await expect(getFilterTags(page).locator(".ux-tag")).toHaveCount(1);
    await expect(
        getFilterTags(page).getByText("Reset all filters")
    ).toBeVisible();
};
